import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { store } from '../stores/store'
import { useTrackController } from './models/track/useTrackController'

export const RunRestartBridge = observer(function RunRestartBridge() {
    const trackController = useTrackController()
    const pending = store.runRestartPending

    useEffect(() => {
        if (!pending) {
            return
        }

        trackController.restartTrack()
        trackController.clearEndDeceleration()
        trackController.setSpeedMultiplier(1)
        trackController.setTrackPaused(false)
        store.setTrackDistance(0)
        store.setTrackProgress(0)
        store.clearRunRestartPending()
    }, [pending, trackController])

    return null
})
